import { Grid, List } from 'react-feather';
import { useAppDispatch } from '../../Redux-Toolkit/Hooks';
import { LI, UL } from '../../AbstractElements';
import { Href } from '../../Constant';
import { setGridView } from '../../Redux-Toolkit/Reducers/BookmarkTabSlice';

const ViewBookmark = () => {
  const dispatch = useAppDispatch()
  const gridBookmark = () => dispatch(()=> dispatch(setGridView(true))) 
  const listBookmark = () => dispatch(()=> dispatch(setGridView(false))) 

  return (
       <UL className= 'simple-list flex-row' >
        <LI><a className="grid-bookmark-view" href={Href}><Grid onClick={gridBookmark} /></a></LI>
        <LI><a className="list-layout-view" href={Href}><List onClick={listBookmark} /></a></LI>
      </UL>
  );
};
export default ViewBookmark;